import { IconArrowsArrowRight } from '@doltech/icons/IconArrowsArrowRight';
import { Button } from '@doltech/ui/lib/figma/ButtonV2/ButtonV2';
import { SkillEnum } from '@doltech/utils/lib/constants';
import cl from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { useTestSubmissionStore } from '../../../model/test-submissions.hook';
import { ButtonQuestionNavigationProps } from '../ButtonQuestionNavigation';

const Main = styled.div`
  display: flex;
  align-items: center;
  .hidden {
    display: none;
  }
  button {
    &:not(:last-child) {
      margin-right: 16px;
    }
  }
`;

export const PracticeTestButtonQuestionNavigation = observer(
  (props: ButtonQuestionNavigationProps) => {
    const store = useTestSubmissionStore();

    const { disableSubmitAction, enableEvent, onSubmitWithEvents } = props;

    switch (store.skill) {
      case SkillEnum.READING: {
        return (
          <Main className="btn-question-navigation">
            <Button.Primary
              onClick={() => {
                if (store.preventUserAction()) return;
                if (enableEvent) {
                  onSubmitWithEvents();
                  return;
                }
                store.openSubmitModal();
              }}
              iconRight={<IconArrowsArrowRight />}
              disabled={disableSubmitAction}
              className={cl('btn-submit-do-test')}
            >
              Submit
            </Button.Primary>
          </Main>
        );
      }
      case SkillEnum.LISTENING: {
        return (
          <Main className="btn-question-navigation">
            <Button.Primary
              onClick={() => {
                if (store.preventUserAction()) return;
                if (enableEvent) {
                  onSubmitWithEvents();
                  return;
                }
                store.openSubmitModal();
              }}
              iconRight={<IconArrowsArrowRight />}
              disabled={disableSubmitAction}
              className="btn-submit-do-test"
            >
              Submit
            </Button.Primary>
          </Main>
        );
      }
      default:
    }
    return null;
  }
);
